const AccessibilityIcon = () => {
  return (
    <svg
      className="accessibility_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="14"
      viewBox="0 0 22 14"
      fill="none"
    >
      <circle cx="11.25" cy="13" r="1" fill="#17171C" />
      <circle cx="11.25" cy="1" r="1" fill="#17171C" />
      <circle cx="17.75" cy="4" r="1" fill="#17171C" />
      <circle cx="14.75" cy="2" r="1" fill="#17171C" />
      <circle cx="14.75" cy="12" r="1" fill="#17171C" />
      <circle cx="17.75" cy="10" r="1" fill="#17171C" />
      <circle cx="20.25" cy="7" r="1" fill="#17171C" />
      <circle cx="11.2871" cy="7" r="3" fill="#17171C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2875 2C8.52605 2 6.28748 4.23858 6.28748 7C6.28748 9.76142 8.52605 12 11.2875 12V14C6.73824 14 2.83401 10.0748 1.15975 8.10299C0.613417 7.45957 0.613416 6.54044 1.15975 5.89701C2.83401 3.92521 6.73824 0 11.2875 0V2Z"
        fill="#17171C"
      />
    </svg>
  )
}

export default AccessibilityIcon
